module.exports = __webpack_public_path__ + "media/images/bnr-early-sm-b5e61f7a4a6ad37a1a9f07a032ead78e.png";